import {useState} from "react";
import {useDispatch} from "react-redux";
import {commentPost} from "../actions";

function CommentForm({ newsId }) {
  let [ name, setName ] = useState('');
  let [ threeSir, setThreeSir ] = useState('');
  let [ content, setContent ] = useState('');
  let [ submitting, setSubmitting ] = useState(false);

  let dispatch = useDispatch();

  let valueSetters = {
    'name': setName,
    'three_sir': setThreeSir,
    'content': setContent
  };

  let submitHandler = (event) => {
    event.preventDefault();
    if (submitting) {
      return;
    }

    let data = {
      'name': name,
      'three_sir': threeSir,
      'content': content
    };
    setSubmitting(true);
    dispatch(commentPost({'id': newsId}, data)).then(() => {
      setName('');
      setThreeSir('');
      setContent('');
    }).then(() => {
      alert('Comment submitted successfully! It will show up if/when it is approved.');
    }).catch(error => {
      alert(`Submit failed: ${error}`);
    }).finally(() => {
      setSubmitting(false);
    });
  }

  let onChangeHandler = (event) => {
    valueSetters[event.target.name](event.target.value);
  }

  return (
    <form method='post' action='' onSubmit={submitHandler} id={'comment_form'}>
      <div>
        <label htmlFor='name'>Name: </label>
        <input type='text' name='name' id='name' maxLength='64' value={name} onChange={onChangeHandler} />
        <br />
        <label htmlFor='three_sir'>What comes next? 1, 2, </label>
        <input type='text' name='three_sir' id='three_sir' maxLength='1' size='1' value={threeSir} onChange={onChangeHandler} /><br />
        <label htmlFor='comment_content'>Comment:</label><br />
        <textarea name='content' id='comment_content' rows='10' cols='35' value={content} onChange={onChangeHandler} /><br />
        <input type='submit' value='Comment' disabled={submitting} />
      </div>
    </form>
  );
}

export default CommentForm;
